import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { InvDiv } from "../Style";
import Output from "./Output";
import Names from "./Names";
import Links from "./Links";
import Footer from "./Footer";
import Extra from "./Extra";
import GenericArivalConfirmation from "./GenericArivalConfirmation";
import { handleClickScroll } from "../others/Functions";
//
const InvitationDemo = ({
  cropAreaAspect,
  picPosition,
  topColor,
  bottomColor,
  heartColor,
}) => {
  const { user } = useSelector((state) => state.authReducer);

  useEffect(() => {
    setTimeout(function () {
      handleClickScroll("bla");
    }, 2000);
  }, []);

  const borderedInvsStyle = {
    width: "100%",
    backgroundColor: "rgba(255,255,255,0.75)",
    boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
    padding: "6px",
    borderRadius: "16px",
    paddingBottom: "24px",
    border: "1px solid rgba(0,0,0,0.06)",
  };
  const basicDivStyle =
    user?.invK === 1 ? { width: "100%" } : borderedInvsStyle;

  return (
    <InvDiv
      gradient={[topColor, bottomColor]}
      style={{
        width: "100%",
        border: "none",
        borderRadius: "20px",
        height: `${window.screen.availHeight}px`,
        maxHeight: "720px",
        maxWidth: "380px",
        padding: user.invK === 1 ? "0" : "20px",
        margin: "20px auto",
        position: "relative",
        boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
      }}
    >
      <div style={{ ...basicDivStyle }}>
        <Output
          _id={user._id}
          pic={user.pic}
          picPosition={picPosition}
          cropAreaAspect={cropAreaAspect}
          isDemo={true}
        />
        {/* {user.inv === 1 && <Names data={user} heartColor={heartColor} />} */}
        <Names data={user} heartColor={heartColor} />
        <GenericArivalConfirmation
          isDemo={true}
          heartColor={heartColor}
          acceptLimit={user.acceptLimit}
          specialDishes={user.specialDishes}
          separation={user.separation}
          seuda={user.seuda}
          transportation={user.transportation}
          specialMsg={user.specialMsg}
          specialMsgDetails={user.specialMsgDetails}
          blessing={user.blessing}
          blessTitle={user.blessTitle}
          transportationDetails={user.transportationDetails}
          invK={user.invK}
        />
        {user.inv === 1 && <Extra data={user} />}
        <Links data={user} />
        {/* לעשות כמו בי סימפל */}
      </div>
      <div style={{ height: "200px" }} />
      <Footer producer={user.producer} />
    </InvDiv>
  );
};

export default InvitationDemo;
